/* eslint react/jsx-sort-props: 0 */
import React from 'react';
import PropTypes from 'prop-types';

interface LargeLogoProps {
 width?: string;
}

export default class LargeLogo extends React.Component<LargeLogoProps> {
    static propTypes = {
        width: PropTypes.string,
    };

    static defaultProps = {
        width: '70%',
    };

    render() {
        return (<svg version="1.1"  xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width={this.props.width} viewBox="0 0 703.235 312.833" enableBackground="new 0 0 703.235 312.833" xmlSpace="preserve">
            <g>
                <path fill="#272A2D" d="M251.621,177.815h-17.76V135.02h17.76c14.262,0,22.681,9.129,22.681,21.397
                    C274.301,168.686,265.882,177.815,251.621,177.815 M244.203,143.936v24.962h6.634c7.417,0,12.766-4.205,12.766-12.481
                    c0-8.271-5.348-12.481-12.766-12.481H244.203z"/>
                <polygon fill="#272A2D" points="303.531,153.774 314.965,177.815 326.573,177.815 304.104,135.02 302.394,135.02 279.999,177.815
                    291.624,177.815"/>
                <polygon fill="#272A2D" points="328.13,135.02 365.362,135.02 365.362,143.936 351.954,143.936 351.954,177.815 341.611,177.815
                    341.611,143.936 328.13,143.936"/>
                <rect x="378.76" y="135.02" fill="#272A2D" width="10.342" height="42.795"/>
                <polygon fill="#272A2D" points="423.613,157.975 435.38,135.02 447.149,135.02 424.682,177.815 422.827,177.815 400.575,135.02
                    412.127,135.02"/>
                <polygon fill="#272A2D" points="587.044,135.02 598.957,135.02 580.494,161.482 580.494,177.815 570.154,177.815 570.154,161.409
                    551.907,135.02 563.816,135.02 575.547,152.042"/>
                <path fill="#272A2D" d="M537.467,167.396c0,0,8.666-4.745,8.666-15.47c0-9.532-7.567-16.906-18.406-16.906h-20.186v42.795h10.34
                    v-12.481h0.003v-8.558h-0.003v-12.84h0.003h8.637h0.776c4.778,0,7.49,4.036,7.49,8.542s-3.268,8.141-8.046,8.141h-5.882
                    L533,177.815h11.461L537.467,167.396z"/>
                <polygon fill="#272A2D" points="468.894,143.936 492.574,143.936 492.574,135.02 458.551,135.02 458.551,177.815 492.574,177.815
                    492.574,168.898 468.894,168.898 468.894,165.072 468.894,160.482 487.723,160.482 487.723,152.353 468.894,152.353
                    468.894,145.192"/>
                <g>
                    <polygon fill="#B08111" points="133.082,147.517 121.252,140.613 121.231,192.116 149.793,208.556 149.793,195.021
                        133.082,185.47"/>
                    <polygon fill="#B08111" points="137.94,150.354 137.984,162.85 149.793,169.385 149.793,157.267"/>
                    <polygon fill="#B08111" points="104.318,182.695 116.145,189.613 116.145,137.635 104.318,130.73"/>
                    <polygon fill="#B08111" points="137.938,182.473 149.793,189.064 149.793,175.511 137.928,168.875"/>
                </g>
                <g>
                    <polygon fill="#DBA40D" points="178.438,140.555 166.542,147.497 166.542,159.891 178.438,153.003"/>
                    <polygon fill="#DBA40D" points="161.605,150.373 149.793,157.267 149.793,169.385 161.612,162.65"/>
                    <polygon fill="#DBA40D" points="149.793,208.556 195.126,182.104 195.126,168.555 149.793,195.021"/>
                    <polygon fill="#DBA40D" points="183.222,137.761 183.222,156.088 149.793,175.511 149.793,189.064 195.126,162.714
                        195.126,130.815"/>
                </g>
                <g>
                    <polygon fillRule="evenodd" clipRule="evenodd" fill="#F3C034" points="137.94,150.354 149.793,157.267 161.605,150.373
                        149.984,143.563"/>
                    <polygon fillRule="evenodd" clipRule="evenodd" fill="#F3C034" points="133.082,133.686 121.252,140.613 133.082,147.517
                        145.169,140.613"/>
                    <polygon fillRule="evenodd" clipRule="evenodd" fill="#F3C034" points="149.65,104.278 137.816,111.186 183.222,137.761
                        195.126,130.815"/>
                    <polygon fillRule="evenodd" clipRule="evenodd" fill="#F3C034" points="104.318,130.73 116.145,137.635 132.908,127.786
                        166.542,147.497 178.438,140.555 132.973,113.99"/>
                </g>
            </g>
        </svg>);
    }
}
